import React, { useState } from 'react';
import { Icon } from '@tt/ui';
import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './FolderStructure.module.scss';

const Folder = ({
  folderData,
  selectedFolder,
  setSelectedFolder,
  expandedFolders,
  isRoot = false,
}) => {
  const [expanded, setExpanded] = useState(
    isRoot || expandedFolders.includes(folderData.location_id),
  );
  const hasChildren =
    folderData.children_folders && folderData.children_folders.length > 0;

  const select = () => {
    setSelectedFolder(folderData);
  };

  const toggleFolderExpansion = () => {
    if (!isRoot) {
      setExpanded(!expanded);
    }
  };

  const isSelected = selectedFolder === folderData.location_id;

  return (
    <div
      className={cx(styles.folderContainer, { [styles.rootFolder]: isRoot })}
    >
      <div
        className={cx(styles.folder, { [styles.selected]: isSelected })}
        onClick={select}
      >
        {hasChildren && (
          <Icon
            name={expanded ? 'chevron-arrow-down' : 'chevron-arrow-right'}
            size="md"
            onClick={toggleFolderExpansion}
          />
        )}
        <Icon
          name={
            hasChildren && expanded ? 'folder-open-filled' : 'folder-filled'
          }
          size="md"
          className={styles.folderIcon}
        />
        <span className={styles.folderText}>
          {folderData.location_type === 'LEASE' && 'Lease: '}
          {folderData.name}
        </span>
        {isSelected && (
          <Icon name="checkmark-plain" className={styles.checkmark} />
        )}
      </div>
      {expanded && (
        <div>
          {folderData.children_folders?.map((child) => (
            <Folder
              key={child.location_id}
              folderData={child}
              selectedFolder={selectedFolder}
              setSelectedFolder={setSelectedFolder}
              onChange={select}
              expandedFolders={expandedFolders}
            />
          ))}
        </div>
      )}
    </div>
  );
};

Folder.propTypes = {
  folderData: PropTypes.object.isRequired,
  isRoot: PropTypes.bool,
  selectedFolder: PropTypes.string,
  expandedFolders: PropTypes.arrayOf(PropTypes.string),
  setSelectedFolder: PropTypes.func.isRequired,
};

export default Folder;
